/* eslint-disable no-unused-vars */
// import Connectors from '../../Charger/Conectors';
import CorporateChargingSessionsGrid from '../CorporateChargingSessionsGrid';
// import ChargingSessions from '../../Charger/ChargingSessions';
// import OCPPLogs from '../../Charger/OCPPLogs';
// import OCPPConnectionHistory from '../../Charger/OCPPConnectionsHistory';
// import ChargerControls from '../../Charger/ChargerControls';
import { useEffect } from 'react';
import {
  Button,
  Typography,
  // Row,
  // Col,
  // Divider,
  Select,
  Spin,
  Tag,
} from 'antd';
import { Row, Col, Card } from 'reactstrap';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { find, get } from 'lodash-es';
import QRCode from 'qrcode.react';
import { DownloadOutlined, PlusCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const { Option } = Select;

export default function UserDetailCard({
  idx,
  detail,
  idTag,
  activePopoverId,
  onClickOutside,
}) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (ref.current && !ref.current.contains(event.target)) {
      //   onClickOutside && onClickOutside();
      // }
      onClickOutside && onClickOutside();
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <>
      <Popover
        placement="right"
        isOpen={activePopoverId === `UserPopover_${idx}_${idTag}`}
        target={`UserPopover_${idx}_${idTag}`}
        className="popover-group"
        style={{ pointerEvents: 'none' }}
      >
        <PopoverHeader>User Details</PopoverHeader>
        <PopoverBody>
          <Card style={{ border: '0px solid #e7e7e9' }}>
            <div>
              <Row>
                <Col sm="5" md="5" lg="5">
                  <strong>Name: </strong>
                </Col>
                <Col sm="7" md="7" lg="7">
                  {get(detail, 'NAME') || 'NA'}
                </Col>
              </Row>
              <Row>
                <Col sm="5" md="5" lg="5">
                  <strong>Phone: </strong>
                </Col>
                <Col sm="7" md="7" lg="7">
                  {get(detail, 'PHONE_NUMBER') || 'NA'}
                </Col>
              </Row>
              <Row>
                <Col sm="5" md="5" lg="5">
                  <strong>Email: </strong>
                </Col>
                <Col sm="7" md="7" lg="7">
                  {get(detail, 'EMAIL') || 'NA'}
                </Col>
              </Row>
            </div>
          </Card>
        </PopoverBody>
      </Popover>
    </>
  );
}
